import StepService from "../StepService";
import StepAddress from "../StepAddress";

export const useCurrentStepComponent = (step) => {
  return {
    service: StepService,
    location: StepAddress,
  }[step];
};
